import { push } from 'react-router-redux';
// import moment from 'moment';
import moment from 'moment';
import { appConstants } from '../constants/appConstants';
import { methodConstants } from '../constants/methodConstants';
import * as ActionCreators from './actionCreators';
import createFocusTrap from 'focus-trap';

let isIE11 = false;
if ( typeof window !== 'undefined' && typeof document !== 'undefined') {
  isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
}

let systemUserId = 0;
let valTimer ;
let focusTrapOne = () => { };
let focusTrapTwo = () => { };
let isMonthsTranslated = false;

const cacheResponsesForTranslations = {};

// eslint-disable-next-line no-unused-vars
let dateDisplayTimeZone = '';
export function setDateDisplayTimeZone(tz) {
  dateDisplayTimeZone = tz;
}

export function isDefined(data) {
  if (typeof data !== 'undefined') {
    return data;
  }
  return false;
}

export function getDateInSpecificFormat(date, format = 'YYYYMMDD') {
  try{
    let changedDate = date;
    if(checkInputDate(date)){
      const splittedDate=splitDate(date);
      changedDate= splittedDate[1] + '/' + splittedDate[0] + '/' + splittedDate[2];
    }
    if (date){
      return moment(changedDate).format(format);
    }else
      return '';
  }
  catch(error){
    return '';
  }
}

export function getDateGenericFormat(date) {
  //CommonActions.getDateMoment(CommonActions.dateHypSlash(scheduleObj.startDate)
  if(date){
    return dateFormatISO(getDateMoment(dateHypSlash(date)));
  }return '';
  // if(date){
  //   let format = 'DD/MM/YYYY';
  //   if(dateFormat){
  //     format = dateFormat.toUpperCase();
  //   }
  //   return moment(date).format(format);
  // }
  // return '';
}

function convertInt(num) {
  return parseInt(num);
}

function formatDate(date) {
  let dt = date;
  if (typeof dt === 'object') {
    dt = date.getDate();
  }
  if (dt < 10) {
    return `0${dt}`;
  }
  return dt;
}


export function dateFormatISO(date) {
  let specificDate;
  if (isDateValid(date)) {
    const dt = moment(date);
    specificDate = `${formatDate(dt.date())}-${appConstants.MONTHS_SMALL[dt.month()]}-${convertInt(dt.year())}`;
    return specificDate;
  }
  return '';
}


export function getDateMoment (val) {
  if (isDefined(val)) {
    return moment(val).toDate();
  } else {
    return moment().toDate();
  }
}

export function checkNum(num) {
  const numVal = parseInt(num);
  if (numVal < 10) {
    return `0${numVal}`;
  }
  return numVal;
}

export function getDateGenericFormatTimeZone(date) {
  const formatVal = 'DD/MM/YYYY';
  if(date){
    let resDt = '';
    if (!isIE11) {
      const event = new Date(date).toLocaleString('en-GB', {timeZone: dateDisplayTimeZone});
      const dtSplit = event.split(', ');
      const strDt = dtSplit[0].split('/');
      const dtFrmt = `${strDt[2]}-${checkNum(strDt[1])}-${checkNum(strDt[0])}T${dtSplit[1]}`;
      resDt = moment(dtFrmt).format(formatVal);
    } else {
      const utcDt = date.split('.')[0];
      const dtSplit = utcDt.split('T');
      const strDt = dtSplit[0].split('-');
      const mn = parseInt(strDt[1], 10);
      const day = parseInt(strDt[2], 10);
      let isDst = false;
      /**
       *  3 - March
       * 11 - November
       * day 10 = 10th day of march
       * day 3 = 3rd day of November
       */
      if (mn >= 3 && mn <= 11) {
        isDst = true;
        if (mn === 3 && day <= 10) {
          isDst = false;
        } else if (mn === 11 && day >= 3) {
          isDst = false;
        }
      }

      let subHours = 7;
      if (isDst) {
        subHours = 6;
      }

      /**
       * subtracting 7 hours from utc for america/denver if non day light saving
       * subtracting 6 hours from utc for america/denver if  day light saving
       */
      resDt = moment(utcDt).subtract(subHours, 'hours').format(formatVal);
    }
    return dateFormatISO(getFormattednewDate(resDt));
  }
  return '';
  //return dateFormatISO(getDateMoment(dateHypSlash(date)));
}

function initFullStoryPageVars(pageUrl) {
  if (pageUrl && pageUrl.length > 0) {
    if (pageUrl.indexOf(`${appConstants.ROUTE_OVERVIEW}`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.overviewPage);
    } else if (pageUrl.indexOf(`${appConstants.ROUTE_MOBILE_DEVICE}`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.pairingCodes);
    } else if (pageUrl.indexOf(`${appConstants.ROUTE_BANK_ACCOUNT}`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.bankAccounts);
    } else if (pageUrl.indexOf(`${appConstants.ROUTE_ORDER_DETAILS}/`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.orderDetails);
    } else if (pageUrl.indexOf(`${appConstants.ROUTE_AWARD_DETAILS}/`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.awardDetails);
    } else if (pageUrl.indexOf(`${appConstants.ROUTE_ORDERS}`) !== -1) {
      setFullStoryPageVars(appConstants.FULL_STORY.orders);
    }
  }
}

export function setOverViewPageEvents(link) {
  switch (link) {
    case '/bankaccounts':
      setFullStoryEvents(appConstants.FULL_STORY.EVENTS.accountsDetailView, appConstants.FULL_STORY.overviewPage);
      break;
    case '/orders':
      setFullStoryEvents(appConstants.FULL_STORY.EVENTS.ordersDetailView, appConstants.FULL_STORY.overviewPage);
      break;
    default:
      setFullStoryEvents(appConstants.FULL_STORY.EVENTS.historyView, appConstants.FULL_STORY.overviewPage);
      break;
  }
}

export function route(routeParam, isTest) {
  return (dispatch) => {
    if(isTest === '' || isTest === undefined)
      dispatch(resetTimer());
    initFullStoryPageVars(routeParam);
    dispatch(push(routeParam));
  };
}

export const resetTimer = () => (dispatch) => {
  clearTimeout(valTimer);
  const timeoutPeriod = 1000 * 60 * 24; // 24 minutes
  //const timeoutPeriod = 10000;
  valTimer = setTimeout(() => {dispatch(displaySession(true)); }, timeoutPeriod); //24 minutes
};

export const displaySession = (value) => (dispatch, getState) => {
  const currentState = getState();
  if(value){
    activateFocusTrap(false);
    activateFocusTrapTwo(false);
  }else{
    if(currentState.isDisplayeCardDialogActions === true ||
      currentState.isDisplayNominationDialogActions === true ||
      currentState.isDisplayProgramDialogActions === true)
      activateFocusTrap(true);
    if(currentState.isDisplayBankDialogActions === true)
      activateFocusTrapTwo(true);
  }
  dispatch(ActionCreators.displaySessionTimeOut(value));
};

export function modifyString(data, key, value) {
  if (data && key && value) {
    const regex = new RegExp(key, 'g');
    return data.replace(regex, value);
  }
  return '';
}

export function toFormat(date, format){
  const specificDate = moment(date).format(format);
  return specificDate;
}

export function errorMessage(message) {
  return infoMessage(message, false, false);
}

export function infoMessage(info, isSuccessBool, isPermissionBool) {
  const obj = {
    message: info,
    isSuccess: isSuccessBool,
    isPermission: isPermissionBool
  };
  return obj;
}

export function formatNumber(num){
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  }).format(num);
}

export function convertToCurrency(num){
  return new Intl.NumberFormat('en-US', {
    style: 'currency', 
    currency: 'USD',
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  }).format(num);
}

export function getLegacyRootUrl(env){
  if(env === 'dev'){
    return appConstants.ROUTE_DEV;
  }else if(env === 'qa'){
    return appConstants.ROUTE_QA;
  }else if(env === 'prod'){
    return appConstants.ROUTE_PROD;
  }else if(env === 'stg'){
    return appConstants.ROUTE_STAGE;
  }
}

export function getFullApiUrl(api, state){
  let basePath = '';
  if(state.basePath){
    basePath = state.basePath;
  }
  if(api === appConstants.ROUTE_HISTORY_RECEIVED 
    || api === appConstants.ROUTE_HISTORY_SENT
    || api === appConstants.ROUTE_LOGO_HOME
    || api === appConstants.ROUTE_CONTACT_US
    || api.indexOf(methodConstants.GET_CATALOG_API) !== -1
    || api.indexOf(methodConstants.GET_NOMINATION_PDF) !== -1){
    basePath = basePath.replace('/ui/accounts', '');
  }
  if(api.indexOf(methodConstants.GET_CATALOG_API) !== -1 || api === methodConstants.LOGOUT){
    basePath = getLegacyRootUrl(state.environment);

    if(api === methodConstants.LOGOUT){
      api = '';
    }
  }
  if(api === appConstants.ROUTE_BANK_ACCOUNT 
    || api === appConstants.ROUTE_ORDERS
    || api === appConstants.ROUTE_MOBILE_DEVICE
    || api === appConstants.ROUTE_OVERVIEW
    || api === appConstants.ROUTE_ORDER_SEARCH
    || api.indexOf(methodConstants.GET_CATALOG_API) !== -1){
    return basePath + api;
  }else{
    return api;
  }
}

export function replaceAllSpecialChars(token){
  if(token !== undefined && token !== null){
    return token.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\]\\\s]/gi, '');
  }
  return token;
}

export function isSatisfied(code) {
  if (code === appConstants.ONKEYPRESS_ENTER_CODE || code === appConstants.ONCLICK_DEFAULT_CODE) {
    return true;
  }
  return false;
}

export function preparePagination(customPagination, total, viewsPerPage, pageNumber){
  const pageNumCount = total > 0 ? Math.ceil(total/viewsPerPage) : 0;
  customPagination.totalPages = pageNumCount;
  customPagination.pageSelected = pageNumber;
  customPagination.pages = [];
  let loopStart = 1;
  let loopEnd = pageNumCount;
  if (pageNumCount > 5) {
    const diffEndPage = pageNumCount - pageNumber;
    if (diffEndPage < 2) {
      loopStart = pageNumCount - 4;
      loopEnd = pageNumCount;
    } else if (pageNumber < 3) {
      loopStart = 1;
      loopEnd = 5;
    } else {
      loopStart = pageNumber - 2;
      loopEnd = pageNumber + 2;
    }
  }
  for (let i = loopStart; i <= loopEnd; i++) {
    customPagination.pages.push(i);
  }
  const pages = customPagination.pages;
  if (pageNumCount === 1) {
    customPagination.pageNext = false;
    customPagination.pagePrevious = false;
  } else if (pageNumber === pages[0]) {
    customPagination.pagePrevious = false;
    customPagination.pageNext = true;
  } else if (pageNumber === pages[pages.length - 1]) {
    customPagination.pagePrevious = true;
    customPagination.pageNext = false;
  } else {
    customPagination.pagePrevious = true;
    customPagination.pageNext = true;
  }

  return customPagination;
}

export function setBodyScroll(isOpen) {
  if (isOpen) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }
  return true;
}

export function manipulateString(str) {
  if (str) {
    str = str.split(' ');
    str = str[0];
  }
  return str;
}

export function concatStrWithComma(str1, str2) {
  if(str1 && str2)
    return str1+', '+ str2;
  else if(str1)
    return str1;
  else if(str2)
    return str2;
}

export function manipulateAddress(str, billing) {
  let value = '';
  if(str){
    if(str.addressLine1){
      const keys = Object.keys(str);
      keys.forEach(key => {
        if(! (billing && key === 'addressLine1')){
          
          if(isDefined(str[key]) && str[key].length > 0 && checkString(str[key])){
            value = concatStrWithComma(value, str[key]);
          }
        }
      });
    }
  }
  return value;
}

export function getExtension(type){
  if(type === appConstants.EXCEL){
    return appConstants.XLS;
  }else if(type === appConstants.PDF){
    return appConstants.PDF;
  }
}

export function getLinkForReport(res, type){
  const blob = new Blob([res], { type: `application/${type}` });// change resultByte to bytes
  const url = window.URL.createObjectURL(blob);
  return url;
}

export function downloadFileFromByteArray(res, fileName, type){
  const newBlob = new Blob([res], { type: `application/${type}` });// change resultByte to bytes
  const link = document.createElement('a');
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob, fileName);
    return;
  }else { // for other browsers
    const url = window.URL.createObjectURL(newBlob);
    link.href = url;
    link.download = `${fileName}.${type}`;
    document.body.appendChild(link);
    link.click();
    setTimeout(function(){
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);  
    }, 1000);      
  }

  
}

export function getFileOpenFromByteArray(res, type){
  const newBlob = new Blob([res], { type: `application/${type}` });// change resultByte to bytes
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const url = window.URL.createObjectURL(newBlob);
  window.open(url,'_blank');
}

export function getAccessCodeStatus(status, showRedeemLink) {
  if(showRedeemLink){
    if(status === 'A'){
      return appConstants.CATALOG;
    }else if(status === 'E'){
      return appConstants.EXPIRED;
    }
  }
  return '';
}

export function validateDates(startDate, endDate){
  startDate = moment(startDate);
  endDate = moment(endDate);
  let errorMsg = '';
  if(startDate.isAfter(endDate)){
    errorMsg = 'Start date cannot be greater than End date.';
  }
  return errorMsg;
}

export function checkDateFilter(obj){

  if(obj.fromDate === '' && obj.toDate === '' ){
    return true;
  }else if(obj.fromDate !== undefined && obj.toDate === '' ){
    return true;
  }else if(obj.fromDate === '' && obj.toDate !== undefined ){
    return true;
  }
  return false;
}

export function checkObjectLength(data) {
  if (Object.keys(data).length > 0) {
    return true;
  }
  return false;
}

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const formatDropdown = (res, keys) => {
  return {
    data: res,
    text: keys.TEXT,
    value: keys.VALUE
  };
};

export const deepClone = (data) => {
  const res = JSON.parse(JSON.stringify(data));
  return res;
};

export const validateEmail = (email) => {
  const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
  return re.test(email);
};

export const numberWithCommas = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const setSystemUserId = (userId) => {
  systemUserId = userId;
};

export const getSystemUserId = () => {
  return systemUserId;
};

export const setCookie = (key, value) => {
  document.cookie = `${key}=${value}`;
};

export const getCookie = (key) => {
  const name = key + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const firstCharUpper = (val) => {
  const splitArr = val.split(/\s/);
  if (splitArr[1]) {
    const resArr = splitArr[1];
    splitArr[1] = resArr[0].toUpperCase() + resArr.slice(1);
  }
  return splitArr.join(' ');
};

export const sortDateByDesc = (arr) => {
  arr.sort(function(a, b) {
    return new Date(b.date) - new Date(a.date);
  });
  return arr;
};

// This function will check the given string and return an object with the type 'plain' or 'email'.
export const tokenize = (lst) => {
  const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return lst.map(function(item) {
    if (re.test(item)) {
      return {
        type: 'email',
        value: item
      };
    }
    return {
      type: 'plain',
      value: item
    };
  });
};

// This function will take an email string, and return an email link
export const renderEmailLink = (email) => {
  return '<a class="help-email" href="mailto:' + email + '">' + email + '</a>';
};

/**
 * This function will NOT work right if email links are not separated with a space,
 * ie: here is a linkexample at example.com, since it checks each word separated by spaces.
 * This function checks whether a string contains an email or not,
 * and converts email links from plain text to <a class="help-email" href="mailto:link"></a>
 * @param {String} content
 */
export const checkForEmails = (content) => {
  const words = content.split(' ');
  const tokens = tokenize(words);
  return tokens.map(function(item) {
    switch(item.type) {
      case 'plain':
        return item.value;
      case 'email':
        return renderEmailLink(item.value);
      default:
        return item.value;
    }
  }).join(' ');
};

export function isEscSatisfied(code) {
  if (code === appConstants.ONKEYPRESS_ESC_CODE) {
    return true;
  }
  return false;
}

export function setFocusTrap() {
  const containerOne = document.getElementById('dialog-box');
  const containerTwo = document.getElementById('dialog-box-details');
  if (containerOne !== null) {
    focusTrapOne = createFocusTrap('#dialog-box', {
      onDeactivate: function () {
        containerOne.className = 'trap';
      }
    });
  }
  if (containerTwo !== null) {
    focusTrapTwo = createFocusTrap('#dialog-box-details', {
      onDeactivate: function () {
        containerTwo.className = 'trap';
      }
    });
  }
}

export function activateFocusTrap(isSetFocus) {
  if (isSetFocus) {
    if (isDefined(focusTrapOne.activate)) {
      setTimeout(function () {
        focusTrapOne.activate();
      }, 0);
    }
  } else {
    if (isDefined(focusTrapOne.deactivate)) {
      focusTrapOne.deactivate();
    }
  }
}

export function activateFocusTrapTwo(isSetFocus) {
  if (isSetFocus) {
    if (isDefined(focusTrapTwo.activate)) {
      setTimeout(function () {
        focusTrapTwo.activate();
      }, 0);
    }
  } else {
    if (isDefined(focusTrapTwo.deactivate)) {
      focusTrapTwo.deactivate();
    }
  }
}

export function getTitle(endPoint){
  // if(endPoint){
  //   switch(endPoint){
  //     case 'overview':
  //       return 'Overview - My Account';
  //     case 'bankaccounts':
  //       return 'Bank account(s) - My Account';
  //     case 'orders':
  //       return 'Orders - My Account';
  //     case 'myAccount':
  //       return 'Pairing Codes - My Account';
  //     case 'pairingcodes':
  //       return 'Pairing Codes - My Account';
  //     case 'ordersearch':
  //       return 'Order Search - Orders';
  //     case 'orderdetails':
  //       return (OrderId ? 'Order Details - '+OrderId+' - Order Tracking and Returns': 'Order Details - Order Tracking and Returns');
  //     case 'awarddetails':
  //       return (OrderId ? 'Award Details - '+OrderId+' - Order Details': 'Award Details - Order Details');
  //   }
  // }
  if(endPoint){
    switch(endPoint){
      case 'overview':
        return 'overview';
      case 'bankaccounts':
        return 'catalog-menu.bank-accounts';
      case 'orders':
        return 'orders';
      case 'myAccount':
        return 'pairing-codes';
      case 'pairingcodes':
        return 'pairing-codes';
      case 'ordersearch':
        return 'order-search';
      case 'orderdetails':
        return 'order-details';
      case 'awarddetails':
        return 'award-details';
    }
  }
  return endPoint;
}

export function getWindowTitle(path){
  let title = '';
  if(path){
    const vars = path.split('/');
    const len = vars.length;
    if(len > 5){
      title = getTitle(vars[len - 3]);
    }else if(len > 4){
      title = getTitle(vars[len - 2]);
    }else{
      title = getTitle(vars[len - 1]);
    }
    // if(len > 5){
    //   title = getTitle(vars[len - 3], vars[len - 1]);
    // }else if(len > 4){
    //   title = getTitle(vars[len - 2], vars[len - 1]);
    // }else{
    //   title = getTitle(vars[len - 1], vars[len -1]);
    // }
  }
  return title;
}

export function engLangPath(data) {
  switch(data){
    case 'overview':
      return 'Overview';
  }
  return '';
}

export function dateFormatCheck(d, formatval) {
  // Date format '/'
  if (formatval.includes('/')) {
    const val = formatval.split('/');
    const datelen = val[0].length;
    const monlen = val[1].length;
    const yearlen = val[2].length;
    let re = null;
    let matchVal = null;
    if(datelen === 2 && monlen === 2 && yearlen === 2){
      re = /^\d{2}\/\d{2}\/\d{2}$/;
    }else if(datelen === 2 && monlen === 2 && yearlen === 4){
      re = /^\d{2}\/\d{2}\/\d{4}$/;
    }else if(datelen === 4 && monlen === 2 && yearlen === 2){
      re = /^\d{4}\/\d{2}\/\d{2}$/;
    }
    matchVal =  d.match(re);
    if(matchVal){
      const dateVal = d.split('/');
      let specificDate;
      switch (formatval){
        case 'DD/MM/YYYY':
          specificDate = `${(dateVal[1])}/${(dateVal[0])}/${(dateVal[2])}`;
          return new Date(specificDate);
        case 'MM/DD/YYYY':
          specificDate = `${(dateVal[0])}/${(dateVal[1])}/${(dateVal[2])}`;
          return new Date(specificDate);
      }
    }else{
      return matchVal;
    }
  }
  return '';
}

export function getIndexFromMapObject(data, value) {
  return data.indexOf(value);
}

export function getArrayIndex(data, value) {
  return getIndexFromMapObject(data, value);
}

export function arrayBufferToString(data) {
  return JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
}

export function checkString(data){
  if(data.length > 0){
    if (/[a-zA-Z]/.test(data))
      return true;
    return false;
  }
  return false;
}

export function isDateValid(dt) {
  let isValid = false;
  if (isDefined(dt) && isDefined(dt.getMonth)) {
    isValid = true;
  }
  return isValid;
}

export function checkDateFormat(date){
  if(date){
    return dateFormatISO(getDateMoment(dateHypSlash(date)));
  }
  // if(date){
  //   if(typeof date === 'string'){
  //     return date;
  //   }
  //   let format = 'DD/MM/YYYY';
  //   if(dateFormat){
  //     format = dateFormat.toUpperCase();
  //   }
  //   return moment(date).format(format);
  // }
  return date;
}

export function validateLocale(val) {
  const pattern = /^[a-z][a-z][-_][A-Z][A-Z]$/;
  const result = pattern.test(val);
  return result;
}

export function sanitizeContent(content) {
  if(content) {
    const sanitizedContent = content.replace(/<script>/g, '')
      .replace(/<\/script>/g, '')
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '')
      .replace(/</g, '')
      .replace(/>/g, '')
      .replace(/&amp;#34;/g, '')
      .replace(/&lt;strong&gt;/g, '')
      .replace(/&lt;\/strong&gt;/g, '')
      .replace(/&lt;em&gt;/g, '')
      .replace(/&lt;\/em&gt;/g, '')
      .replace(/&lt;u&gt;/g, '')
      .replace(/&lt;\/u&gt;/g, '')
      .replace(/&lt;p&gt;/g, '')
      .replace(/&lt;\/p&gt;/g, '')
      .replace(/&amp;#39;/g, '');
    return sanitizedContent;
  }
  return '';
}

export function dateHypSlash(dt, typeDate) {
  if (typeof dt === 'string' && dt.length > 0) {
    dt = dt.split(' ')[0];
    if (typeDate) {
      dt = getDateMoment(moment(dt));
    }
  }
  return dt;
}

function translatedData(data, trans) {
  const arr = [];
  data.forEach(function(item) {
    arr.push(trans[item]);
  });
  return arr;
}

export function setCacheResponsesForTranslations(key, data) {
  cacheResponsesForTranslations[key] = deepClone(data);
}

export function getCacheResponsesForTranslations(key) {
  return deepClone(cacheResponsesForTranslations[key]);
}

export function setMonthsWeeksLocalization(trans, isForceUpdate) {
  if (!isMonthsTranslated) {
    setCacheResponsesForTranslations(
      appConstants.CACHE_FOR_TRANSLATIONS.MONTHS_SMALL,
      appConstants.MONTHS_SMALL
    );
  }
  if (!isMonthsTranslated || isForceUpdate) {
    isMonthsTranslated = true;
    appConstants.MONTHS_SMALL = translatedData(
      getCacheResponsesForTranslations(
        appConstants.CACHE_FOR_TRANSLATIONS.MONTHS_SMALL
      ),
      trans
    );
  }
}

export function isNotNumber(val) {
  if (isNaN(val)) {
    return true;
  }
  return false;
}

export function formatManuallyEnteredDate(date) {
  const day = date[0];
  let month = date[1];
  const year = date[2];

  let formattedDate = '';
  if(isNotNumber(Number(month))) {
    formattedDate = new Date(month+','+day+','+year);
  } else {
    formattedDate = new Date(month+'/'+day+'/'+year);
  }
  if(formattedDate.toString()===appConstants.INVALID_DATE) {
    const months = appConstants.MONTHS_SMALL.map(item => item.toLowerCase());
    let monthIndex = '';
    month = month.toLowerCase();
    if(months.indexOf(month) !== -1) {
      monthIndex = months.indexOf(month)+1;
    }
    else {
      return appConstants.INVALID_DATE;
    }
    formattedDate = new Date(monthIndex+'/'+day+'/'+year);
  }
  if(formattedDate.toString()!==appConstants.INVALID_DATE && parseInt(day,10)!==formattedDate.getDate()) {
    return appConstants.INVALID_DATE;
  }
  return formattedDate;
}

export function splitDate(date) {
  if(date.includes('-')) {
    return date.split('-');
  } else if(date.includes('/')) {
    return date.split('/');
  } else if(date.includes(' ')) {
    return date.split(' ');
  } else return '';
}

export function checkInputDate(date) {
  if(date) {
    if(date.length >= 8 && date.length <= 11){
      return true;
    }
    return false;
  } 
  return false;
}

export function datesplitCheck(d){
  const date = splitDate(d);
  const day = date[0];
  const month = date[1];
  const year = date[2];
  if(date.length === 3){
    if(day.length <= 2){
      if(month.length <= 3){
        if(year.length === 4){
          return true;
        }
      }
    }
  }
  return false;
}

export function getFormattedDate(d){
  const date = splitDate(d);
  const val = getDateMoment(moment([date[2], date[1], date[0]]).subtract(1, 'month'));
  return val;
}

export function getFormattednewDate(d){
  const date = splitDate(d);
  const val = formatManuallyEnteredDate(date);
  return val;
}

export function initFullStory(userId, customerId) {
  if(isDefined(userId) && isDefined(customerId) && window.FS) {
    const displayNameStr = userId ? userId.toString() : '';
    const customerIdentityStr = customerId ? customerId.toString() : '';
    const userVars =   {
      displayName: displayNameStr,
      soldToParty_str: customerIdentityStr,
      systemUserID_str: displayNameStr
    };
    window.FS.identify(userId, userVars);
  }
}


export function setFullStoryPageVars(featureStr) {
  if(isDefined(featureStr) && window.FS) {
    window.FS.setVars('page', {
      octPlatform_str: appConstants.FULL_STORY.legacyPlatform,
      octFeature_str: featureStr
    });
  }
}

export function setFullStoryEvents(eventStr, featureStr) {
  if(isDefined(eventStr) && isDefined(featureStr) && window.FS) {
    window.FS.event(eventStr, {
      keyAction_str: eventStr,
      octFeature_str: featureStr
    });
  }
}
